import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { FilteringRuleSliceDTO } from './types'

export const FILTERING_RULE_FRAGMENT_FOR_UPDATE: TypedDocumentNode<FilteringRuleSliceDTO> = gql`
  fragment FilteringRuleFragmentForUpdate on FilteringRule {
    applicableDomains
    blocked
    domainIds
    id
    name
  }
`
